var exports = {
  "k": "x127c5a35--beba20--container",
};

module.exports = exports;
